var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4999 22H22.9999V20H23.4999C24.6933 20.0477 25.8569 19.6194 26.7346 18.8093C27.6122 17.9991 28.1321 16.8735 28.1799 15.68C28.2276 14.4865 27.7993 13.323 26.9891 12.4453C26.179 11.5676 25.0533 11.0477 23.8599 11H22.9999L22.8999 10.18C22.678 8.49645 21.8517 6.95094 20.575 5.83138C19.2982 4.71182 17.658 4.09455 15.9599 4.09455C14.2618 4.09455 12.6215 4.71182 11.3448 5.83138C10.068 6.95094 9.24172 8.49645 9.01986 10.18L8.99986 11H8.13986C6.94638 11.0477 5.82076 11.5676 5.0106 12.4453C4.20044 13.323 3.77212 14.4865 3.81986 15.68C3.8676 16.8735 4.38749 17.9991 5.26516 18.8093C6.14283 19.6194 7.30638 20.0477 8.49986 20H8.99986V22H8.49986C6.89626 21.9898 5.35302 21.3873 4.16684 20.3081C2.98066 19.2289 2.23528 17.7494 2.07399 16.1539C1.9127 14.5584 2.3469 12.9596 3.29311 11.6649C4.23932 10.3701 5.63074 9.47088 7.19986 9.14C7.63157 7.12652 8.74069 5.32197 10.3422 4.02747C11.9437 2.73296 13.9406 2.02679 15.9999 2.02679C18.0591 2.02679 20.0561 2.73296 21.6575 4.02747C23.259 5.32197 24.3682 7.12652 24.7999 9.14C26.369 9.47088 27.7604 10.3701 28.7066 11.6649C29.6528 12.9596 30.087 14.5584 29.9257 16.1539C29.7644 17.7494 29.0191 19.2289 27.8329 20.3081C26.6467 21.3873 25.1035 21.9898 23.4999 22Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8703 30.5L14.1303 29.5L17.2803 24H11.2803L16.1303 15.5L17.8703 16.5L14.7203 22H20.7203L15.8703 30.5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.172b7b5aa7557c3e249e60bed9d100bd.svg";
export { ForwardRef as ReactComponent };